import { useRef, useEffect } from 'react'
import videoIcon from '../../assets/icons/video-icon.svg'
import openLockIcon from '../../assets/icons/lock-open-alt 1.svg'
import closeLockIcon from '../../assets/icons/lock-close-alt 1.svg'
import videoThumbnail from '../../assets/images/video_thumbnail.jpg'

function CourseVideo({  playingVideo, shortId, isExpired, isAccessible }) {
  
  const ref = useRef(null)

  const handleFullScreenChange = () => {
    if (
      !document.fullscreenElement &&
      !document.webkitFullscreenElement &&
      !document.mozFullScreenElement &&
      !document.msFullscreenElement
    ) {
      ref.current.removeAttribute('controls')
      ref.current.pause()
    }
  }

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullScreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullScreenChange)
    document.addEventListener('mozfullscreenchange', handleFullScreenChange)
    document.addEventListener('MSFullscreenChange', handleFullScreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange)
      document.removeEventListener('webkitfullscreenchange', handleFullScreenChange)
      document.removeEventListener('mozfullscreenchange', handleFullScreenChange)
      document.removeEventListener('MSFullscreenChange', handleFullScreenChange)
    }
  }, [])

  const handlePlay = async (shortId) => {
    if (ref.current) {
      if (ref.current.paused) {
        if (playingVideo && playingVideo !== ref.current) {
          playingVideo.pause()
          playingVideo.removeAttribute('controls')
        }
        if (ref.current.requestFullscreen) {
          await ref.current.requestFullscreen()
        } else if (ref.current.mozRequestFullScreen) {
          await ref.current.mozRequestFullScreen()
        } else if (ref.current.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          await ref.current.webkitRequestFullscreen()
        } else if (ref.current.msRequestFullscreen) {
          /* IE/Edge */
          await ref.current.msRequestFullscreen()
        }
        // eslint-disable-next-line no-undef
        ref.current.src = `${process.env.REACT_APP_LIVE_URL}/course/module/topic/upload-video/${shortId}`
        ref.current.setAttribute('controls', 'controls')
        ref.current.play()
      } else {
        ref.current.pause()
        ref.current.removeAttribute('controls')
      }
    }
  }

  return (
    <div className='video-left'>
      <img src={videoIcon} alt='video' />
      <video
        width='154'
        height='95'
        ref={ref}
        controlsList='nodownload'
        onPause={() => {
          ref.current.removeAttribute('controls')
        }}
        poster={videoThumbnail}
      />
      <div className='video-control'>
        <span className='flex align-center'>
          <img className='video-control-lock' src={isExpired || !isAccessible ? closeLockIcon : openLockIcon} alt='video' />
          {isExpired ? 'Deactivated' : 'Activated till 48 hours'}
        </span>
        <button
          className='video-play-btn'
          disabled={isExpired || !isAccessible}
          onClick={() => {
            handlePlay(shortId)
          }}
        >
          Play
        </button>
      </div>
    </div>
  )
}

export default CourseVideo
